import React from 'react';

const UnderConstruction = () => {
    return (
        <div className="under-construction" style={{
            padding: 'var(--spacing-section) 0',
            maxWidth: '800px',
            margin: '0 auto',
            textAlign: 'center'
        }}>
            <h2 style={{ fontSize: '2rem', marginBottom: '1rem', fontWeight: 500 }}>
                Work in Progress
            </h2>
            <div style={{
                fontFamily: "'JetBrains Mono', monospace",
                color: 'var(--text-secondary)',
                fontSize: '0.9rem',
                border: '1px solid #eee',
                padding: '1.5rem',
                display: 'inline-block',
                borderRadius: '4px'
            }}>
                <span style={{ color: 'var(--accent-green)' }}>status:</span> building<br />
                <span style={{ color: 'var(--accent-green)' }}>eta:</span> soon...<br />
                <span style={{ color: 'var(--accent-green)' }}>message:</span> "Stay tuned."
            </div>
        </div>
    );
};

export default UnderConstruction;
